import React, { FC } from 'react'

import { AnswerHTML } from 'pages/frequent-questions/utils/replace-link-tags'

import { Text } from '@interco/inter-ui/components/Text'
import { interWbNavigate } from '@interco/inter-webview-bridge'

import { ArticleLink } from './styles'

export const LinkParagraph: FC<AnswerHTML> = ({ text, link }) => {
  if (!text || !link) return null

  const splittedParagraph = text.split(link.text || '')

  return (
    <Text variant="body-3">
      {splittedParagraph[0].at(splittedParagraph[0].length - 1) === ' '
        ? splittedParagraph[0]
        : `${splittedParagraph[0]} `}

      <ArticleLink variant="body-3" onClick={() => interWbNavigate.openDeepLink(link.href || '')}>
        {link.text}
      </ArticleLink>

      {splittedParagraph[1]}
    </Text>
  )
}
